import { render } from "./SlideCoBorrower.vue?vue&type=template&id=e142d52e&scoped=true"
import script from "./SlideCoBorrower.vue?vue&type=script&lang=js"
export * from "./SlideCoBorrower.vue?vue&type=script&lang=js"

import "./SlideCoBorrower.vue?vue&type=style&index=0&id=e142d52e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e142d52e"]])

export default __exports__